module.exports = __webpack_public_path__ + "static/img/publicSpaces.7aad6097.png";